<template>
  <div>
    <div class="regional1"></div>
    <div class="regional2">
      <el-form ref="elForm" inline style="margin-left: 20px;">
        <el-form-item style="margin-right: 20px;">
          <el-input v-model="query.area_name" placeholder="请输入合区名" clearable
            @keyup.enter.native="handleCurrentChange(1)">
          </el-input>
        </el-form-item>
        <el-form-item style="margin-right: 20px;">
          <el-button type="primary" @click="handleCurrentChange(1)" icon="el-icon-search"
            v-if="JudgeButton(role_permission,'regional/query')"> 查询 </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="newlyAdded" icon="el-icon-circle-plus"
            v-if="JudgeButton(role_permission,'regional/increase')"> 新增 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="regional3" v-loading='loading'>
      <el-table stripe border ref="multipleTable" :data="tableData" style="width: 60%" tooltip-effect="dark">
        <el-table-column align='center' prop="area_name" label="合区名" width="180" show-overflow-tooltip>
        </el-table-column>

        <el-table-column align='center' label="系统区域" show-overflow-tooltip>
          <span slot-scope="scope">
            <span v-for="(item,index) in scope.row.area_code" :key="index">{{ item}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </el-table-column>

        <el-table-column label="操作" width="240" align='center'>

          <template slot-scope="scope">

            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)"
              v-if="JudgeButton(role_permission,'regional/edit')">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)"
              v-if="JudgeButton(role_permission,'regional/delete')">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <div class="regional4">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
        :page-sizes="[10, 30, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
        :total="count">
      </el-pagination>
    </div>


    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="30%" v-el-drag-dialog @close='close'>
      <el-form ref="added" :model="form" :rules="rules" size="medium" label-width="130px">
        <el-form-item label="合区名：" prop="name">
          <el-input v-model="form.name" placeholder="请输入合区名" :maxlength='15' show-word-limit clearable
            :style="{width: '60%'}">
          </el-input>
        </el-form-item>
        <el-form-item label="系统区域：" prop="type">
          <el-checkbox-group v-model="form.type" true-label='form.area_code'>
            <el-checkbox v-for="(i,l) in selectionList" :key="l" :label="i.area_name"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="handelConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import elDragDialog from "@/utils/el-dragDialog";
  import userInfoAPI from '@/api/api';
  export default {
    name: 'regionalManage',
    props: {},
    data() {
      return {
        count: 0,
        tableData: [],
        title: '',
        dialogFormVisible: false,
        form: {
          name: '',
          type: [],
          area_id: '',
        },
        rules: {
          name: [{
            required: true,
            message: '请输入合区名',
            trigger: 'blur'
          }],
          type: [{
            type: 'array',
            required: true,
            message: '请至少选择一个系统区域',
            trigger: ['change', 'blur']
          }]
        },
        selectionList: [],
        loading: true,
        query: {
          area_name: "",
          page_limit: 10,
          page: 1
        }
      }
    },
    directives: {
      elDragDialog,
    },
    created() {
      if (this.$store.state.cache.cacheRegionalQuery) this.query = this.$store.state.cache.cacheRegionalQuery
      this.init();
    },
    beforeDestroy() {
      this.$store.commit('CACHE_REGIONAL', this.query)
    },
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      },
    },
    methods: {
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },

      init() {
        userInfoAPI.systemSelectionList().then(({
          data
        }) => {
          if (data.code == 0) {
            this.selectionList = data.data;
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
          this.init1();
        })
      },
      init1() {
        this.loading = true
        userInfoAPI.selectionList(this.query).then(({
          data
        }) => {
          if (data.code == 0) {
            this.count = data.data.page.count * 1;
            this.tableData = data.data.list;
            this.tableData.forEach(j => {
              let area_code = [];
              j.area_code.forEach(l => {
                this.selectionList.forEach(i => {
                  if (l === i.area_code) {
                    area_code.push(i.area_name)
                  }
                })
              })
              j.area_code = area_code;
            })
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
          this.loading = false
        }).catch((err) => {

        });
      },
      handleSizeChange(val) {
        this.query.page_limit = val;
        this.init1();
      },
      handleCurrentChange(val) {
        this.query.page = val;
        this.init1();
      },
      newlyAdded() {
        this.dialogFormVisible = true;
        this.title = '新增';
        this.form.name = '';
        this.form.type = [];
        this.form.area_id = '';

      },
      handleEdit(index, row) { //编辑
        this.title = '编辑用户：' + row.area_name;
        this.form.name = row.area_name;
        this.form.type = row.area_code;
        this.form.area_id = row.area_id;
        this.dialogFormVisible = true;
      },
      handleDelete(index, row) { //删除
        this.$confirm('此操作将永久删除该区域, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.createArea2(row.area_id).then(({
            data
          }) => {
            if (data.code == 0) {
              this.init1();
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'success'
              });
            } else {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'error'
              });
            }
          })
        })
      },
      close() { //弹窗关闭
        this.$refs['added'].resetFields(); //强制清理表格内容 
        this.dialogFormVisible = false;
      },
      handelConfirm() { //弹窗确认功能按钮
        this.$refs['added'].validate(valid => {
          if (valid) {
            let area_code = [];
            this.selectionList.forEach(i => {
              this.form.type.forEach(l => {
                if (l === i.area_name) {
                  area_code.push(i.area_code)
                }
              })
            })
            if (this.title == '新增') {
              userInfoAPI.createArea({
                area_name: this.form.name,
                area_code
              }).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.close();
                  this.init1();
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  });
                } else {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  });
                }
              }).catch((err) => {

              });
            } else {

              userInfoAPI.createArea1({
                area_name: this.form.name,
                area_code
              }, this.form.area_id).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.close();
                  this.init1();
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  });
                } else {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  });
                }
              }).catch((err) => {

              });
            }
          } else {
            //   this.$message({
            //   showClose: true,
            //   message:'根据要求填写信息',
            //   type: 'error'
            // });
          }
        })
      },
    }
  }
</script>
<style lang='scss' scoped>
  .regional1 {
    height: 20px;
  }

  .regional3 {
    margin-left: 20px;
    margin-bottom: 20px;
  }

  .regional4 {
    margin-left: 38%;
  }
</style>
